import { isObject, } from './isObject';

export interface AddressData {
	houseNumber?: string;
	street: string;
	supplementaryLine1?: string;
	supplementaryLine2?: string;
	supplementaryLine3?: string;
	city: string;
	country: string;
	region?: string;
	postcode: string;
}

export function isAddressData(input: unknown): input is AddressData {
	const isOptionalString = (obj: Record<string, unknown>, prop: Extract<keyof AddressData, string | undefined>) => typeof obj[prop] === 'string' || typeof obj[prop] === 'undefined';

	return isObject(input) &&
		isOptionalString(input, 'houseNumber') &&
		typeof input.street === 'string' &&
		isOptionalString(input, 'supplementaryLine1') &&
		isOptionalString(input, 'supplementaryLine2') &&
		isOptionalString(input, 'supplementaryLine3') &&
		typeof input.city === 'string' &&
		typeof input.country === 'string' &&
		isOptionalString(input, 'region') &&
		typeof input.postcode === 'string' &&
		true;
}

export interface IMovingDetails {
	newAddress: AddressData | null;
	moveInDate: Date | null;
	isCorrespondenceAddress: boolean;
	correspondenceAddress: AddressData | null;
	occupancyType: 'Owner' | 'Tenant';
	noPersons: number | null;
	personsToDisplayText: string | null;
	// selectedDate: string | null;
}

export interface CustomerAddressDetails {
	houseNumber?: string;
	street?: string;
	supplementaryLine1?: string;
	supplementaryLine2?: string;
	supplementaryLine3?: string;
	city?: string;
	country?: string;
	region?: string;
	postcode?: string;
}

export interface NewCustomerCreationData {
	title?: string;
	firstName?: string;
	middleName?: string;
	lastOrgName?: string;
	dateOfBirth?: Date;
	insuranceNumber?: string;
	customerAddressDetails?: CustomerAddressDetails;
	mobileNumberCountryCode?: string;
	mobileNumber?: string;
	telephoneNumberCountryCode?: string;
	telephoneNumber?: string;
	emailAddress?: string;
}

export interface SubmitMoveinAddressData {
	customerNumber?: string;
	moveInDate?: Date;
	supplementaryLine1?: string;
	supplementaryLine2?: string;
	supplementaryLine3?: string;
	houseNumber?: string;
	street?: string;
	city?: string;
	region?: string;
	postcode?: string;
	country?: string;
	occupancyType?: string;
}

export interface ConfirmMoveinData {
	emailId?: string;
	customerNumber?: string;
	premiseId?: string;
	moveInDate?: Date;
	vacantProperty?: string;
	noBedrooms?: string;
	noPersons?: string;
	occupancyType?: string;
	productId?: string;
	newMeterNo?: string;
	newMeterCategory?: string;
	newMeterRead?: string;
	newReadDate?: string;
	newReadType?: string;
	supplementaryLine1?: string;
	supplementaryLine2?: string;
	supplementaryLine3?: string;
	houseNumber?: string;
	street?: string;
	city?: string;
	region?: string;
	postcode?: string;
	country?: string;
}
